import React from 'react';
import { SEOData } from '../types';

interface SEOProps {
  data: SEOData;
}

export const SEO: React.FC<SEOProps> = ({ data }) => {
  React.useEffect(() => {
    // Update document title
    document.title = data.title;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', data.description);
    }
    
    // Update keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', data.keywords.join(', '));
    }
    
    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', data.title);
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', data.description);
    }
    
    // Update canonical URL if provided
    if (data.canonical) {
      let canonicalLink = document.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute('href', data.canonical);
    }
    
    // Update OG image if provided
    if (data.ogImage) {
      const ogImage = document.querySelector('meta[property="og:image"]');
      if (ogImage) {
        ogImage.setAttribute('content', data.ogImage);
      }
    }
    
    // Add structured data for local business
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Vidrería la Cañadita. Vidrios y Aluminios",
      "description": "Especialistas en Puertas, Ventanas, Cancelería de baños, Barandales, Espejos, Vidrios de diferentes espesor. Trabajos garantizados en Santa María Atzompa.",
      "url": "https://vidrerialacanadita.com",
      "telephone": "+52 951 321 4264",
      "email": "contacto@vidrerialacanadita.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Col. La cañadita",
        "addressLocality": "Santa María Atzompa",
        "addressRegion": "Oaxaca",
        "addressCountry": "MX"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "17.0732",
        "longitude": "-96.7266"
      },
      "openingHours": [
        "Mo-Fr 08:00-18:00",
        "Sa 08:00-14:00"
      ],
      "priceRange": "$$",
      "servesCuisine": [],
      "serviceArea": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "17.0732",
          "longitude": "-96.7266"
        },
        "geoRadius": "50000"
      },
      "areaServed": "Oaxaca, México",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Servicios de Vidrios y Aluminios",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Puertas",
              "description": "Instalación y fabricación de puertas de aluminio y vidrio"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Ventanas",
              "description": "Ventanas de aluminio a medida con aislamiento térmico"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service", 
              "name": "Cancelería de baños",
              "description": "Canceles de vidrio templado para baño con herrajes de calidad"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Barandales",
              "description": "Barandales de aluminio y vidrio para escaleras y balcones"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Espejos",
              "description": "Espejos decorativos y funcionales con instalación profesional"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Vidrios de diferentes espesor",
              "description": "Vidrios templados, laminados y flotados para cualquier aplicación"
            }
          }
        ]
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "reviewCount": "50",
        "bestRating": "5",
        "worstRating": "1"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Cliente Satisfecho"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "reviewBody": "Excelente servicio, trabajo de calidad y puntualidad. Los recomiendo ampliamente."
        }
      ],
      "sameAs": [
        "https://facebook.com/vidrerialacanadita",
        "https://instagram.com/vidrerialacanadita"
      ]
    };
    
    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
    
  }, [data]);

  return null; // This component doesn't render anything
};